import { IncomingMessage } from 'http';

import { fechFromBPartsApi } from './utils';

export const fetchFaqsSchema = (
  {
    locale,
  }: {
    locale: string;
  },
  req?: IncomingMessage
) =>
  fechFromBPartsApi(
    `/${locale}/shop/faqs/schema`,
    {
      credentials: 'include',
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
    },
    { enableCustomErrorWrapper: true }
  );
